/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Qbank_Generate_CtaInputs */

const en_interview_qbank_generate_cta = /** @type {(inputs: Interview_Qbank_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Questions`)
};

const de_interview_qbank_generate_cta = /** @type {(inputs: Interview_Qbank_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragen generieren`)
};

const fr_interview_qbank_generate_cta = /** @type {(inputs: Interview_Qbank_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer les questions`)
};

const es_interview_qbank_generate_cta = /** @type {(inputs: Interview_Qbank_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar preguntas`)
};

const it_interview_qbank_generate_cta = /** @type {(inputs: Interview_Qbank_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera domande`)
};

const nl_interview_qbank_generate_cta = /** @type {(inputs: Interview_Qbank_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer vragen`)
};

const pl_interview_qbank_generate_cta = /** @type {(inputs: Interview_Qbank_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generuj pytania`)
};

const fi_interview_qbank_generate_cta = /** @type {(inputs: Interview_Qbank_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo kysymyksiä`)
};

const da_interview_qbank_generate_cta = /** @type {(inputs: Interview_Qbank_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer spørgsmål`)
};

const sv_interview_qbank_generate_cta = /** @type {(inputs: Interview_Qbank_Generate_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generera frågor`)
};

/**
* | output |
* | --- |
* | "Generate Questions" |
*
* @param {Interview_Qbank_Generate_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_qbank_generate_cta = /** @type {((inputs?: Interview_Qbank_Generate_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Qbank_Generate_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_qbank_generate_cta(inputs)
	if (locale === "fr") return fr_interview_qbank_generate_cta(inputs)
	if (locale === "es") return es_interview_qbank_generate_cta(inputs)
	if (locale === "it") return it_interview_qbank_generate_cta(inputs)
	if (locale === "nl") return nl_interview_qbank_generate_cta(inputs)
	if (locale === "pl") return pl_interview_qbank_generate_cta(inputs)
	if (locale === "fi") return fi_interview_qbank_generate_cta(inputs)
	if (locale === "da") return da_interview_qbank_generate_cta(inputs)
	if (locale === "sv") return sv_interview_qbank_generate_cta(inputs)
	return en_interview_qbank_generate_cta(inputs)
});